<template>
  <div id="data-cleansing-page">
    <!-- floating loader component -->
    <floating-loader-component v-if="is_loading || is_float_loading" />
    <!-- page component -->
    <transition name="block">
      <div class="px-2">
        <div class="card card-default shade" style="margin-top: 15px;">
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h3 style="font-size: 20px">
                      <i class="bi bi-eraser"></i> Data Cleansing
                    </h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      Halaman untuk mengelola berita. Silakan gunakan format
                      excel yang tersedia untuk melakukan cleansing data. Mohon
                      tidak mengedit kolom yang tidak diizinkan untuk diedit.
                    </p>
                  </div>
                  <div class="col-md-12 mt-3">
                    <div class="d-flex align-items-center">
                      <button
                        v-if="file_input"
                        class="ml-auto btn btn-lg btn-success"
                        type="button"
                        id="submit-data"
                        @click="uploadFile()"
                      >
                        Simpan
                      </button>
                      <button
                        v-if="file_input"
                        class="ml-2 btn btn-lg btn-warning"
                        type="button"
                        id="reset-data"
                        @click="resetData"
                      >
                        Reset
                      </button>
                      <button
                        :class="file_input ? 'ml-2' : 'ml-auto'"
                        class="btn btn-lg btn-complete"
                        type="button"
                        id="upload-data"
                        @click="showModalUpload"
                      >
                        <span v-if="!file_input">Upload Data</span>
                        <span v-else>Edit Data</span>
                      </button>
                      <button
                        id="download-template"
                        type="button"
                        class="btn btn-lg btn-success float-right ml-2"
                        @click="downloadTemplate"
                      >
                        Download Template
                      </button>
                      <router-link to="history-cleansing">
                        <button
                          id="riwayat-cleansing"
                          type="button"
                          class="btn btn-lg btn-warning float-right ml-2"
                        >
                          Riwayat Data Cleansing
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6" v-if="file_input">
                <div class="border border-lg row rounded p-2 mb-3 mt-3">
                  <div class="col-md-2">
                    <h6>Periode</h6>
                  </div>
                  <div class="col-md-10" v-if="periode.start && periode.end">
                    <h6>: {{ periode_start }} - {{ periode_end }}</h6>
                  </div>
                  <div class="col-md-10" v-else>
                    <h6>: -</h6>
                  </div>
                  <div class="col-md-2">
                    <h6>Jenis Data</h6>
                  </div>
                  <div class="col-md-10">
                    <h6>
                      :
                      {{
                        tipe == "medsos" ? "Media Sosial" : "Media Online"
                      }}
                    </h6>
                  </div>
                  <div class="col-md-2">
                    <h6>Nama File</h6>
                  </div>
                  <div class="col-md-10">
                    <h6>: {{ file_input ? file_input.name : "-" }}</h6>
                  </div>
                  <div class="col-md-2">
                    <h6>ID Task</h6>
                  </div>
                  <div class="col-md-10">
                    <h6>: {{ id_task ? id_task : "-" }}</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-12" v-if="is_max">
                <div class="alert alert-info">
                  <i class="bi bi-info-circle mr-1">
                    Note: Datacleansing yang ditampilkan pada preview hanya 100
                    baris teratas</i
                  >
                </div>
              </div>
              <div class="col-md-12 table-responsive mt-3" id="table">
                <table
                  v-if="show_table && tipe == 'medkon' && file_input != null"
                  id="cleantable"
                >
                  <thead>
                    <tr>
                      <th>ID Berita</th>
                      <th>Konten</th>
                      <th>Judul</th>
                      <th>Tanggal</th>
                      <th>Grup</th>
                      <th>Topik</th>
                      <th>Akun</th>
                      <th>Jurnalis</th>
                      <th>Sumber</th>
                      <th>Url</th>
                      <th>Sentimen</th>
                      <th>Emotion</th>
                      <th>AD Value</th>
                      <th>PR Value</th>
                      <th>AMEC Value</th>
                      <th>Halaman</th>
                      <th>Jenis Akun</th>
                      <th>Lokasi</th>
                      <th>Narasumber</th>
                      <th v-if="is_news_trend == 1">Newstrend</th>
                      <th>Tier Media</th>
                      <th>Dihapus</th>
                      <th>Status Validasi</th>
                    </tr>
                  </thead>

                  <tbody></tbody>
                </table>
                <table
                  v-else-if="
                    show_table && tipe == 'medsos' && file_input != null
                  "
                  id="cleantablemedsos"
                >
                  <thead>
                    <tr>
                      <th>ID Berita</th>
                      <th>Konten</th>
                      <th>Tanggal</th>
                      <th>Topik</th>
                      <th>Akun/Judul</th>
                      <th>Sumber</th>
                      <th>Url</th>
                      <th>Sentimen</th>
                      <th>Emotion</th>
                      <th>Engagement</th>
                      <th>ESMR</th>
                      <th>Followers</th>
                      <th>Likes</th>
                      <th>Retweets</th>
                      <th>Views</th>
                      <th>Lokasi</th>
                      <th>Jenis Akun</th>
                      <th>Jenis Unggahan</th>
                      <th v-if="is_news_trend == 1">Newstrend</th>
                      <th>Dihapus</th>
                      <th>Status Validasi</th>
                    </tr>
                  </thead>

                  <tbody></tbody>
                </table>
              </div>
              <div class="col-md-12 mt-2" v-if="file_input">
                <button
                  type="button"
                  class="btn btn-lg btn-s pull-right"
                  :class="
                    file_input != null ? 'btn  btn-success' : 'btn  btn-default'
                  "
                  :disabled="file_input != null ? false : true"
                  @click="uploadFile"
                >
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- dynamic modal component -->
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="currentModal.data"
      :static="true"
    />
    <!-- tour component -->
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    />
  </div>
</template>
<script>
import XLSX from "xlsx";
import $ from "jquery";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_download_template from "@/views/components/datacleansing/modal_download_template.vue";
import modal_upload_data from "@/views/components/datacleansing/modal_upload_data.vue";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";
import moment from "moment";
$.pgNotification = notif;

var modals = {
  title: "Ekspor Data Cleansing",
  subtitle: "Silahkan masukan inputan yang tersedia",
  component: modal_download_template,
};

export default {
  name: "DataCleansing",
  title: "Data Cleansing | Sibernetik",
  components: {
    "modal-dynamic-component": modal_dynamic,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      is_max: false,
      file_input: null,
      data: [],
      modal_key: 10,
      currentModal: null,
      is_loading: false,
      is_float_loading: false,
      tipe: "",
      show_table: false,
      is_disabled: false,
      tour_steps: [],
      id_task: "",
      periode: {
        start: null,
        end: null,
      },
      is_news_trend: this.$store.getters.user.project.project_detail.news_trend,
    };
  },
  methods: {
    resetData: function () {
      if (this.tipe == "medkon") {
        this.table = $("#cleantable").DataTable();
        this.table.destroy();
      } else {
        this.table = $("#cleantablemedsos").DataTable();
        this.table.destroy();
      }
      this.is_disabled = false;
      this.tipe = "";
      this.periode.start = null;
      this.periode.end = null;
      this.id_task = null;
      this.file_input = null;
      this.is_max = false;
    },
    downloadTemplate: function () {
      this.modal_key++;
      this.currentModal = modals;
    },
    getData: function (f) {
      let file = f.target.files[0];
      this.file_input = file;
    },
    setData: function () {
      if (this.file_input != null) {
        this.data = [];
        let arr_data = [];
        let reader = new FileReader();
        reader.onload = (e) => {
          let data = e.target.result,
            workbook = XLSX.read(data, { type: "binary" }),
            sheetName =
              workbook.SheetNames.length == 3 && this.tipe == "medkon"
                ? workbook.SheetNames[2]
                : workbook.SheetNames[1],
            sheet = workbook.Sheets[sheetName];
          let dataJSON = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          let length_value = 0;
          let data_valueable = dataJSON.filter((el) => el.length != 0);
          if (data_valueable.length > 101) {
            this.is_max = true;
            length_value = 101;
          } else {
            this.is_max = false;
            length_value = data_valueable.length;
          }
          for (let row = 0; row < length_value; row++) {
            let rowData = {};
            for (let col = 0; col < dataJSON[row].length; col++) {
              let header = dataJSON[0][col];
              let value = dataJSON[row][col];
              rowData[header] = value;
            }
            if (row > 0 && "UUID" in rowData) {
              arr_data.push(rowData);
            }
          }
          this.data = [...new Set(arr_data)];
          this.table.clear();
          this.assemblyData(this.data);
        };
        reader.readAsBinaryString(this.file_input);
      }
    },
    assemblyData: function (data) {
      this.is_loading = true;
      if (this.tipe == "medkon") {
        let kolom_nt = [
          { data: "UUID" },
          { data: "Konten" },
          { data: "Judul" },
          { data: "Tanggal", defaultContent: "-" },
          { data: "Grup", defaultContent: "-" },
          { data: "Topik", defaultContent: "-" },
          { data: "Akun", defaultContent: "-" },
          { data: "Jurnalis", defaultContent: "-" },
          { data: "Sumber", defaultContent: "-" },
          { data: "Url", defaultContent: "-" },
          { data: "Sentimen", defaultContent: "-" },
          { data: "Emotion", defaultContent: "-" },
          { data: "Ad Value", defaultContent: "-" },
          { data: "PR Value", defaultContent: "-" },
          { data: "AMEC", defaultContent: "-" },
          { data: "Halaman", defaultContent: "-" },
          { data: "Jenis Akun", defaultContent: "-" },
          { data: "Location", defaultContent: "-" },
          { data: "Narasumber", defaultContent: "-" },
          { data: "News Trend", defaultContent: "-" },
          { data: "Tier Media", defaultContent: "-" },
          { data: "Dihapus : 1 jika Ya", defaultContent: "NO" },
          { data: "Is Validated", defaultContent: "NO" },
        ];
        let kolom = [
          { data: "UUID" },
          { data: "Konten" },
          { data: "Judul" },
          { data: "Tanggal", defaultContent: "-" },
          { data: "Grup", defaultContent: "-" },
          { data: "Topik", defaultContent: "-" },
          { data: "Akun", defaultContent: "-" },
          { data: "Jurnalis", defaultContent: "-" },
          { data: "Sumber", defaultContent: "-" },
          { data: "Url", defaultContent: "-" },
          { data: "Sentimen", defaultContent: "-" },
          { data: "Emotion", defaultContent: "-" },
          { data: "Ad Value", defaultContent: "-" },
          { data: "PR Value", defaultContent: "-" },
          { data: "AMEC", defaultContent: "-" },
          { data: "Halaman", defaultContent: "-" },
          { data: "Jenis Akun", defaultContent: "-" },
          { data: "Location", defaultContent: "-" },
          { data: "Narasumber", defaultContent: "-" },
          { data: "Tier Media", defaultContent: "-" },
          { data: "Dihapus : 1 jika Ya", defaultContent: "NO" },
          { data: "Is Validated", defaultContent: "NO" },
        ];
        this.table = $("#cleantable").DataTable({
          autoWidth: false,
          scrollX: true,
          destroy: true,
          ordering: false,
          data: data,
          createdRow: function (row, data) {
            var keys = Object.keys(data);
            var dihapus = keys[9];
            var value = data[dihapus];
            if (value && (value == 1 || value == "YES" || value == "yes")) {
              $(row).addClass("red");
            }
          },
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: this.is_news_trend == 1 ? kolom_nt : kolom,
          columnDefs: [
            {
              render: function (data, type, row) {
                let div =
                  '<div class="scroller" style="width:800px;text-align:justify; max-height:10rem;">' +
                  row.Konten +
                  "</div>";
                return div;
              },
              targets: 1,
            },
            {
              render: function (data, type, row) {
                let div = '<div style="width:250px;">' + row.Judul + "</div>";
                return div;
              },
              orderable: false,
              targets: 2,
            },
            {
              render: function (data, type, row) {
                let div =
                  '<div style="width:250px;">' +
                  row.Tanggal +
                  " " +
                  row.Jam +
                  "</div>";
                return div;
              },
              orderable: false,
              targets: 3,
            },
            {
              render: function (data, type, row) {
                let div = '<div style="width:250px;">' + row.Topik + "</div>";
                return div;
              },
              orderable: false,
              targets: 4,
            },
            {
              render: function (data, type, row) {
                let div =
                  '<div class="scroller" style="width:250px;text-align:justify; max-height:10rem;">' +
                  row.Narasumber +
                  "</div>";
                return div;
              },
              targets: 18,
            },
            {
              render: function (data, type, row) {
                let is_deleted = "NO";
                if (row["Dihapus : 1 jika Ya"] == 1) {
                  is_deleted = "YES";
                } else {
                  is_deleted = " NO";
                }
                let div = '<div style="width:250px;">' + is_deleted + "</div>";
                return div;
              },
              orderable: false,
              targets: this.is_news_trend == 1 ? 21 : 20,
            },
            {
              render: function (data, type, row) {
                let is_validated = "NO";
                if (
                  row["Is Validated"] == true ||
                  row["Is Validated"] == "YES" ||
                  row["Is Validated"] == 1
                ) {
                  is_validated = "YES";
                } else {
                  is_validated = "NO";
                }
                let div =
                  '<div style="width:250px;">' + is_validated + "</div>";
                return div;
              },
              orderable: false,
              targets: this.is_news_trend == 1 ? 22 : 21,
            },
          ],
        });
        setInterval(() => {
          this.is_loading = false;
        }, 1000);
      } else if (this.tipe == "medsos") {
        let kolom_nt = [
          { data: "UUID" },
          { data: "Konten" },
          { data: "Tanggal", defaultContent: "-" },
          { data: "Topik", defaultContent: "-" },
          { data: "Akun/Judul", defaultContent: "-" },
          { data: "Sumber", defaultContent: "-" },
          { data: "Url", defaultContent: "-" },
          { data: "Sentimen", defaultContent: "-" },
          { data: "Emotion", defaultContent: "-" },
          { data: "Engagement", defaultContent: "-" },
          { data: "ESMR", defaultContent: "-" },
          { data: "Followers", defaultContent: "-" },
          { data: "Likes", defaultContent: "-" },
          { data: "Retweets", defaultContent: "-" },
          { data: "View", defaultContent: "-" },
          { data: "Location", defaultContent: "-" },
          { data: "Jenis Akun", defaultContent: "-" },
          { data: "Jenis Unggahan", defaultContent: "-" },
          { data: "News Trend", defaultContent: "-" },
          { data: "Dihapus  1 Jika Ya / 0 Jika Tidak" },
          { data: "Is Validated", defaultContent: "-" },
        ];
        let kolom = [
          { data: "UUID" },
          { data: "Konten" },
          { data: "Tanggal", defaultContent: "-" },
          { data: "Topik", defaultContent: "-" },
          { data: "Akun/Judul", defaultContent: "-" },
          { data: "Sumber", defaultContent: "-" },
          { data: "Url", defaultContent: "-" },
          { data: "Sentimen", defaultContent: "-" },
          { data: "Emotion", defaultContent: "-" },
          { data: "Engagement", defaultContent: "-" },
          { data: "ESMR", defaultContent: "-" },
          { data: "Followers", defaultContent: "-" },
          { data: "Likes", defaultContent: "-" },
          { data: "Retweets", defaultContent: "-" },
          { data: "View", defaultContent: "-" },
          { data: "Location", defaultContent: "-" },
          { data: "Jenis Akun", defaultContent: "-" },
          { data: "Jenis Unggahan", defaultContent: "-" },
          { data: "Dihapus  1 Jika Ya / 0 Jika Tidak" },
          { data: "Is Validated", defaultContent: "-" },
        ];
        this.table = $("#cleantablemedsos").DataTable({
          autoWidth: false,
          scrollX: true,
          destroy: true,
          ordering: false,
          data: data,
          createdRow: function (row, data) {
            var keys = Object.keys(data);
            var dihapus = keys[7];
            var value = data[dihapus];
            if (value && (value == 1 || value == "YES" || value == "yes")) {
              $(row).addClass("red");
            }
          },
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: this.is_news_trend == 1 ? kolom_nt : kolom,
          columnDefs: [
            {
              render: function (data, type, row) {
                let div =
                  '<div class="scroller" style="width:800px;text-align:justify; max-height:10rem;">' +
                  row.Konten +
                  "</div>";
                return div;
              },
              targets: 1,
            },
            {
              render: function (data, type, row) {
                let div =
                  '<div style="width:250px;">' +
                  row.Tanggal +
                  " " +
                  row.Jam +
                  "</div>";
                return div;
              },
              orderable: true,
              targets: 2,
            },
            {
              render: function (data, type, row) {
                let div = '<div style="width:250px;">' + row.Topik + "</div>";
                return div;
              },
              orderable: false,
              targets: 3,
            },
            {
              render: function (data, type, row) {
                let is_deleted = "NO";
                if (row["Dihapus  1 Jika Ya / 0 Jika Tidak"] == 1) {
                  is_deleted = "YES";
                } else {
                  is_deleted = "NO";
                }
                let div = '<div style="width:250px;">' + is_deleted + "</div>";
                return div;
              },
              orderable: false,
              targets: this.is_news_trend == 1 ? 19 : 18,
            },
            {
              render: function (data, type, row) {
                let is_validated = "NO";
                if (
                  row["Is Validated"] == true ||
                  row["Is Validated"] == "YES" ||
                  row["Is Validated"] == 1
                ) {
                  is_validated = "YES";
                } else {
                  is_validated = "NO";
                }
                let div =
                  '<div style="width:250px;">' + is_validated + "</div>";
                return div;
              },
              orderable: false,
              targets: this.is_news_trend == 1 ? 20 : 19,
            },
          ],
        });
        setInterval(() => {
          this.is_loading = false;
        }, 1000);
      }
    },
    uploadFile: function () {
      this.is_float_loading = true;
      let formData = new FormData();
      formData.append("file", this.file_input);
      formData.append("id_project", this.$store.getters.user.id_project);
      formData.append("tipe", this.tipe);
      formData.append("user", this.$store.getters.user.user);
      formData.append("id_task", this.id_task);
      formData.append(
        "periode_data",
        moment(this.periode.start).format("YYYY-MM-DD HH:mm:ss") +
          " - " +
          moment(this.periode.end).format("YYYY-MM-DD HH:mm:ss")
      );
      let api = process.env.VUE_APP_API_URL + "new-import-datacleansing-excel";
      this.$http
        .post(api, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.status == 200) {
            this.resetData();
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> File Berhasil di upload.',
                position: "top",
                timeout: 4000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> Error! Terjadi kesalahan saat mengupload data.',
              position: "top",
              timeout: 4000,
              type: "error",
            })
            .show();
        })
        .finally(() => {
          this.is_float_loading = false;
        });
    },
    showModalUpload: function () {
      this.modal_key++;
      this.currentModal = {
        title: "Upload Data Cleansing",
        subtitle: "Silahkan masukan inputan yang tersedia",
        component: modal_upload_data,
        data: {
          tipe: this.tipe,
          file_input: this.file_input,
          id_task: this.id_task,
          periode: {
            start: this.periode.start,
            end: this.periode.end,
          },
        },
      };
    },
    setDataFromModal: function (tipe, file, id_task, periode) {
      this.tipe = tipe;
      this.file_input = file;
      this.id_task = id_task;
      this.periode = periode;
      this.is_max = false;
    },
  },
  computed: {
    periode_start() {
      return moment(this.periode.start).format("YYYY-MM-DD HH:mm:ss");
    },
    periode_end() {
      return moment(this.periode.end).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  watch: {
    tipe() {
      if (this.file_input != null) {
        this.show_table = true;
        this.is_disabled = true;
        this.setData();
        this.assemblyData();
      }
    },
    file_input() {
      if (this.tipe != "") {
        this.show_table = true;
        this.is_disabled = true;
        this.setData();
        this.assemblyData();
      }
    },
  },
  mounted() {
    let v_step = [];
    v_step[0] = {
      target: "#upload-data",
      header: {
        title: "Upload Data",
      },
      content: "Klik untuk melakukan upload data cleansing",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#download-template",
      header: {
        title: "Download Template",
      },
      content: "Klik untuk melakukan download template file excel",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#riwayat-cleansing",
      header: {
        title: "Riwayat Data Cleansing",
      },
      content:
        "Klik untuk melihat riwayat data cleansing yang pernah dilakukan",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#table",
      header: {
        title: "Tabel Hasil Upload Data Excel",
      },
      content: "Data yang di upload dari file excel akan ditampilkan disini",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>
<style>
.px200 {
  width: 300px;
  max-width: 300px;
  word-wrap: break-word;
}
.red {
  background-color: #fde2da !important;
}
</style>
